
import { defineStore } from 'pinia'

export const usePartnerHowWorks = defineStore('partnerHowWorks', {
  state: () => ({
    steps: [
      {
        id: 1,
        mediaSrc: "icon-hands",
        title: "Desenho de mãos se apertando",
        text: "Após a contratação de um serviço ou produto, nós cuidamos de tudo!",
      },
      {
        id: 2,
        mediaSrc: "icon-plane",
        title: "Desenho de avião de papel com estrelas em volta",
        text: "Enviamos, sempre que necessário, comunicações para te notificar sobre prazos e pagamentos.",
      },
      {
        id: 3,
        mediaSrc: "icon-bell",
        title: "Desenho de sineta",
        text: "Dessa forma, você recebe notificações e não deixa nenhum assunto importante passar batido.",
      },
    ] as Array<ContentCardItem>
  }),

  getters: {
    getSteps: (state) => state.steps,
  },
})